/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor', 'kimi']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * @param {string} mobile
 * @returns {Boolean}
 */
export function validMobile(mobile) {
  const reg = /^1\d{10}$/
  return reg.test(mobile)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**验证码
 * @param str
 * @returns {boolean}
 */
export function valiCaptcha(str) {
  return str.trim().length == 4
}

/* 受否是手机号|电话号码 */
export function isMobile(str) {
    return /^(1[3456789][0-9]{9}|(0[0-9]{2,3}\-?)?[2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/.test(str);
}


/**
 * @method isPassword
 * 密码复杂度
 * @param pwd
 * @returns {boolean}
 */
export function isPassword(pwd){
  return /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/.test(pwd);
}

/**
 * @method isChinese
 * 检查是否为汉字
 * @param {string} str
 * @returns {boolean}
 */
export function isChinese(str){
  return /[\u4E00-\u9FA5\uF900-\uFA2D]/.test(str);
}

/**
 * @method isUserName
 * 检查是否合法用户名
 * @param {string} str
 * @returns {boolean}
 */
export function isUserName(str){
  return /^[0-9a-zA-Z_]{3,24}$/.test(str);
}

/**
 * @method isNumber
 * 检查是否是纯数字
 * @param {string} str
 * @returns {boolean}
 */
export function isNumber(str){
	return /^[0-9]*$/.test(str);
}

export function isStr(str){
	return /^[a-zA-Z]*$/.test(str);
}

export function isRuleStr(str){
	return /^[a-zA-Z0-9]*$/.test(str);
}